<lib-custom-progress-spinner
  #vcCustomProgressSpinnerComponent
></lib-custom-progress-spinner>
<form
  [formGroup]="loginForm"
  (ngSubmit)="onSubmit()"
  class="bg-surface-ground flex items-center justify-center min-h-screen min-w-screen overflow-hidden"
>
  <div class="flex flex-col items-center justify-center">
    <div
      style="
        border-radius: 56px;
        padding: 0.3rem;
        background: linear-gradient(
          180deg,
          var(--primary-color) 10%,
          rgba(33, 150, 243, 0) 30%
        );
      "
    >
      <div
        class="w-full bg-surface-card py-20 px-8 sm:px-20 lg:px-24"
        style="border-radius: 53px"
      >
        <div class="text-center mb-8">
          <div class="text-surface-900 text-3xl font-medium mb-4">
            {{ tittle1() }}
          </div>
          <div class="text-surface-900 text-3xl font-medium mb-4">
            {{ tittle2() }}
          </div>
          <div class="text-surface-600 font-medium mb-4">v2.0.57</div>
        </div>

        <div>
          <div class="flex flex-col items-center w-full">
            <div class="w-full md:w-[30rem]">
              <label
                for="username"
                class="block text-surface-900 text-xl font-medium mb-2 text-left"
                >Usuario</label
              >
              <input
                id="username"
                type="text"
                pInputText
                formControlName="username"
                maxlength="150"
                class="w-full mb-8"
                style="padding: 1rem; text-align: left"
              />
              @let usernameCtrl = loginForm.controls['username'];
              @if (usernameCtrl.invalid && (usernameCtrl.dirty || usernameCtrl.touched)) {
                <small class="p-error block -mt-6 mb-6 text-left">Ingrese su usuario.</small>
              }

              <label
                for="password"
                class="block text-surface-900 font-medium text-xl mb-2 text-left"
                >Contraseña</label
              >
              <p-password
                inputId="password"
                [feedback]="false"
                [toggleMask]="true"
                [fluid]="true"
                styleClass="mb-8"
                inputStyleClass="p-4"
                formControlName="password"
                [maxLength]="4096"
                [inputStyle]="{ 'text-align': 'left' }"
              ></p-password>
              @let passwordCtrl = loginForm.controls['password'];
              @if (passwordCtrl.invalid && (passwordCtrl.dirty || passwordCtrl.touched)) {
                <small class="p-error block -mt-6 mb-6 text-left">Ingrese su contraseña.</small>
              }
            </div>
          </div>

          <div class="flex items-center justify-between mb-8 gap-8">
            @if (rememberMe()) {
              <div class="flex items-center">
                <p-checkbox
                  inputId="rememberme1"
                  [binary]="true"
                  styleClass="mr-2"
                ></p-checkbox>
                <label for="rememberme1">Remember me</label>
              </div>
            }
            @if (showForgotPassword()) {
              <a
                class="font-medium no-underline ml-2 text-right cursor-pointer"
                style="color: var(--primary-color)"
                >Forgot password?</a
              >
            }
          </div>
          <button pButton pRipple type="submit" class="w-full p-4 text-xl">
            Iniciar Sesión
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
